export const formatPriceToLocale = (price?: number | string): string => {
  if (!price) return '0';
  const num = typeof price === 'string' ? parseFloat(price) : price;
  if (isNaN(num)) return '0';
  return num.toLocaleString('ru-RU');
};